import React, { useState } from "react";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import RichTextEditor from "components/common/RichTextEditor";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import { addRole, updateRole } from "services/permission";
import { useForm } from "react-hook-form";
import { useSnackbar } from "notistack";
import { StyledRoleDialog } from "./Role.style";

const RoleDlg = (props) => {
  const initRole = {
    name: "",
    description: "",
  };

  const { enqueueSnackbar } = useSnackbar();

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const { onSubmit } = props;
  const [role, setRole] = useState(initRole);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const openDlg = (editRole) => {
    reset();
    setRole(editRole || initRole);
    setValue("name", editRole?.name || "");
    setValue("description", editRole?.description || "");
    setIsEditMode(editRole ? true : false);
    setOpen(true);
  };

  const handleAction = async (data) => {
    setLoading(true);
    try {
      const response = isEditMode
        ? await updateRole({ ...data, id: role.id })
        : await addRole(data);
      if (response.rtnCode === 200) {
        enqueueSnackbar(isEditMode ? "Role updated." : "Role created.", {
          variant: "success",
        });
        onSubmit();
        handleClose();
      } else {
        enqueueSnackbar(isEditMode ? "Role update failed." : "Role creation failed.", {
          variant: "warning",
        });
      }
    } catch {
      enqueueSnackbar(isEditMode ? "Role update failed." : "Role creation failed.", {
        variant: "warning",
      });
    } finally {
      setLoading(false);
    }
  };

  const dlg = (
    <StyledRoleDialog open={open} onClose={handleClose}>
      <DialogTitle>
        <div className="dialog-title-group">
          <h2 className="dialog-title">
            {isEditMode ? "Edit Role" : "Add New Role"}
          </h2>
          <p className="dialog-subtitle">
            Define role metadata used for permission assignments.
          </p>
        </div>
      </DialogTitle>
      <form onSubmit={handleSubmit(handleAction)}>
        <DialogContent>
          <Box>
            <FormControl fullWidth>
              <TextField
                label="Name"
                variant="outlined"
                size="small"
                fullWidth
                defaultValue={role.name}
                {...register("name", { required: true })}
                error={!!errors?.name}
                helperText={!!errors?.name ? "* Name is required" : " "}
              />
            </FormControl>
          </Box>
          <Box>
            <FormControl fullWidth>
              <RichTextEditor
                value={role.description || ""}
                onChange={(value) => {
                  setValue("description", value);
                  setRole({ ...role, description: value });
                }}
                label="Description"
                placeholder="Enter role description..."
                toolbarConfig="description"
                minHeight="120px"
                error={!!errors?.description}
                helperText={!!errors?.description ? "* Description is required" : " "}
              />
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-cancel-btn"
            variant="outlined"
            size="medium"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className="dialog-submit-btn"
            type="submit"
            variant="contained"
            size="medium"
            disabled={loading}
          >
            {isEditMode ? "Update" : "Create"}
          </Button>
        </DialogActions>
      </form>
    </StyledRoleDialog>
  );

  return [openDlg, dlg, loading];
};

export default RoleDlg;
